<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addurl"
        >
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("message") }}</label>
                <app-input
                  type="textarea"
                  :placeholder="$t('enter_message')"
                  v-model="inputs.message"
                  :required="true"
                />
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("users") }}</label>
                <app-input
                  type="search-select"
                  :placeholder="$t('select_user')"
                  :list="this.users"
                  v-model="inputs.user_id"
                  :required="true"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group">
                <label>{{ $t("due_date") }}</label>
                <app-input
                  type="date"
                  v-model="inputs.due_date"
                  :placeholder="$t('select_valid_date')"
                />
              <!-- :min-date="new Date()" -->
              </div>
            </div>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    taskId: String,
    type: String,
  },
  data() {
    return {
      users: [],
      addurl: actions.TASK_ENDORSEMENT_REQUEST,
      preloader: false,
      inputs: {
        due_date: new Date(),
      },
      modalId: "endorsement-request-send-Modal",
      modalTitle: this.$t("request_endorsement"),
    };
  },
  //   created() {
  //     if (this.selectedUrl) {
  //       this.modalTitle = this.$t("edit");
  //       // this.postUrl = actions.MYDOCUMENT_UPDATE;
  //       // this.preloader = true;
  //     }
  //   },
  methods: {
    submit() {
       if (this.inputs.due_date)
            this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
      this.inputs.task_id = this.taskId;
      this.inputs.type = this.type; 
      this.save(this.inputs);
    },
    afterSuccess(res) {
      this.preloader = false;
      this.hideModal();
      this.$toastr.s(res.data.message);
      this.$emit("afterSubmitDone");
    },
    afterError() {
      this.preloader = false;
      this.closeModal();
    },
    hideModal() {
      $("#" + this.modalId).modal("hide");
    },
    closeModal() {
      this.hideModal();
      this.$emit("close-modal");
    },
    getUsers() {
      axiosGet(actions.GET_COMPANY_USERS)
        .then((res) => {
          this.users = res.data;
        })
        .catch((error) => {
          
        });
    },
  },

  mounted() {
    this.getUsers();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
